import React, { useRef } from 'react'
import { Input } from 'reactstrap'
import styled from 'styled-components'
import { useDashboardRedux } from '@hooks'

const SearchWrapper = styled.div`
    display: flex;
    align-items: center;
    position: relative;
`

const SearchIcon = styled.div`
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    position: ${props => (props.$isExpanded ? 'absolute' : 'relative')};
    right: ${props => (props.$isExpanded ? '10px' : '0')};
    z-index: 2;
    transition: all 0.3s ease;
`

const SearchInput = styled(Input)`
    width: ${props => (props.$isExpanded ? '200px' : '0')};
    padding-right: ${props => (props.$isExpanded ? '35px' : '0')};
    opacity: ${props => (props.$isExpanded ? '1' : '0')};
    transition: all 0.3s ease;
    border-radius: 20px;

    &:focus {
        box-shadow: none;
        border-color: #ced4da;
    }
`

const MenuSearchBar = () => {
    // const [isExpanded, setIsExpanded] = useState(true)
    const isExpanded = true
    const wrapperRef = useRef(null)
    const { searchValue, setSearchValue } = useDashboardRedux()

    const handleIconClick = () => {}

    const handleInputChange = e => {
        setSearchValue(e.target.value)
    }

    const handleKeyPress = e => {}

    return (
        <SearchWrapper ref={wrapperRef}>
            <SearchInput
                type="text"
                placeholder={isExpanded ? 'Search...' : ''}
                value={searchValue}
                onChange={handleInputChange}
                onKeyPress={handleKeyPress}
                $isExpanded={isExpanded}
                className={`${searchValue ? 'border-primary border-3' : 'border-dark'}`}
            />
            <SearchIcon $isExpanded={isExpanded} onClick={handleIconClick}>
                <i className={`bx bx-sm bx-search ${searchValue ? 'text-primary' : 'text-dark'}`} />
            </SearchIcon>
        </SearchWrapper>
    )
}

export default MenuSearchBar
